/** @jsx jsx */

import { formatDistanceToNowStrict } from 'date-fns';

import { css, jsx } from '@emotion/core';
import { Icon } from '@zapier/zinnia-icons';
import { Grid, Tooltip, TooltipFocusableTrigger } from '@zapier/design-system';

import ZapCount from './ZapCount';

import type { Version } from './types';

const Styles = {
  tooltip: css`
    min-width: 200px;
  `,
  tooltipContainer: css`
    display: flex;
    align-items: center;
  `,
  userCount: css`
    align-items: center;
    display: flex;
    gap: 5px;
  `,
};

type Props = {
  integrationId: number;
  version: Version;
};

function ColumnActivity({ integrationId, version }: Props) {
  const hasCount =
    typeof version.userCount === 'number' && version.userCountUpdatedAt;

  return (
    <div css={Styles.tooltipContainer}>
      <Grid alignItems="center" columns="repeat(2, max-content)" gap="5px">
        <Icon name="personOneFill" size={16} />
        <Tooltip
          allowMultiline={true}
          content={
            hasCount
              ? `Count of users who currently have a Zap turned on. These Zaps might not have generated tasks yet. Updated ${formatDistanceToNowStrict(
                  version.userCountUpdatedAt * 1000,
                  { addSuffix: true }
                )}.`
              : 'Count of users who currently have a Zap turned on. These Zaps might not have generated tasks yet. The number is not available yet. Come back later.'
          }
        >
          <TooltipFocusableTrigger>
            <div css={Styles.userCount}>
              {hasCount ? (
                version.userCount
              ) : (
                <Icon name="alertInfo" size={16} />
              )}
            </div>
          </TooltipFocusableTrigger>
        </Tooltip>
        <Icon name="miscBoltAltFill" size={16} />
        <ZapCount integrationId={integrationId} version={version.version} />
      </Grid>
    </div>
  );
}

export default ColumnActivity;
